export default __webpack_public_path__ + "static/media/img@2x.ee88332d.png";